import React from "react";
import {
    Slider,
    TopProduct,
    TrendingNow,
    TrendingMain,
    HighLight,
    NewArrival,
    ShoppingLink,
    GiftGuide,
    FurniturePlace,
    FeelGoodFind,
    SoulStyle,
} from "./includes";

function Theme1(props) {
    return (
        <>
            <Slider />

            <ShoppingLink />

            <TopProduct />

            <TrendingNow />

            <TrendingMain />

            <HighLight />

            <NewArrival />

            <GiftGuide />

            <FurniturePlace />

            <FeelGoodFind />

            <SoulStyle />
        </>
    );
}

export default Theme1;
